var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnexionImageBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1485.749,
    height: 459.819,
    viewBox: "0 0 1485.749 459.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9734",
    "data-name": "Groupe 9734",
    transform: "translate(-3.066 -0.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9632",
    "data-name": "Groupe 9632",
    transform: "translate(2.512 3.811)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9630",
    "data-name": "Groupe 9630",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9622",
    "data-name": "Groupe 9622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9618",
    "data-name": "Groupe 9618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9611",
    "data-name": "Groupe 9611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9606",
    "data-name": "Groupe 9606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9599",
    "data-name": "Groupe 9599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9596",
    "data-name": "Groupe 9596",
    transform: "translate(0.151 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9518",
    "data-name": "Groupe 9518",
    transform: "translate(1028.27 173.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16086",
    "data-name": "Trac\\xE9 16086",
    d: "M41.141,192.451.653,51.79l.514-.135,40,138.979L103.211,1.3l53.571,93.786,136.564-2.871.024.534L156.483,95.627l-.081-.142L103.35,2.608Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9519",
    "data-name": "Groupe 9519",
    transform: "translate(1321.434 265.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16087",
    "data-name": "Trac\\xE9 16087",
    d: "M154.92,159.845l-.7-.725L0,.372.384,0,153.892,158.03,125.55,50.688l.516-.124Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9520",
    "data-name": "Groupe 9520",
    transform: "translate(930.481 293.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16088",
    "data-name": "Trac\\xE9 16088",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9521",
    "data-name": "Groupe 9521",
    transform: "translate(809.082 217.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16089",
    "data-name": "Trac\\xE9 16089",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9522",
    "data-name": "Groupe 9522",
    transform: "translate(541.342 207.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16090",
    "data-name": "Trac\\xE9 16090",
    d: "M2.02,160.164,44.556.561,66.5,82.264l-.5.122.132.11ZM44.562,2.629,3.176,157.915,65.721,82.15l.26.217Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9523",
    "data-name": "Groupe 9523",
    transform: "translate(47.62 184.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16091",
    "data-name": "Trac\\xE9 16091",
    d: "M2.8,188.5l-.43-.327,55-73.181L117.192,1.477l.169.692,26.616,108.8L305.823,22.3l88.032,32.664-.175.5-87.8-32.579-162.251,88.9L117.012,2.976,57.822,115.287Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9524",
    "data-name": "Groupe 9524",
    transform: "translate(267.89 206.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16092",
    "data-name": "Trac\\xE9 16092",
    d: "M160.273,159.675,39.466,141.835l.1-.305L85.191,1.739.263,14.185l-.091-.528,85.8-12.573L40.174,141.4l120.164,17.746Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9525",
    "data-name": "Groupe 9525",
    transform: "translate(83.435 151.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16093",
    "data-name": "Trac\\xE9 16093",
    d: "M184.3,68.9,169.427,2.7.184,11.752l-.042-.533,169.7-9.079.051.227L184.825,68.8Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9526",
    "data-name": "Groupe 9526",
    transform: "translate(92.842 294.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16094",
    "data-name": "Trac\\xE9 16094",
    d: "M1.966,155.92,12.142,4.459,58.985,64,98.353,1.239l.455.291L59.34,64.452,131.9,156.678l-.417.324L59.042,64.927ZM12.584,5.873,2.644,153.824,58.687,64.476Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9527",
    "data-name": "Groupe 9527",
    transform: "translate(353.471 207.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16095",
    "data-name": "Trac\\xE9 16095",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9528",
    "data-name": "Groupe 9528",
    transform: "translate(164.722 187.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16096",
    "data-name": "Trac\\xE9 16096",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9529",
    "data-name": "Groupe 9529",
    transform: "translate(148.433 113.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16313",
    "data-name": "Trac\\xE9 16313",
    d: "M0,0H.527L.358,159.723H-.169Z",
    transform: "translate(0.005 0.399) rotate(-48.431)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9530",
    "data-name": "Groupe 9530",
    transform: "translate(441.388 240.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16097",
    "data-name": "Trac\\xE9 16097",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9531",
    "data-name": "Groupe 9531",
    transform: "translate(698.119 138.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16098",
    "data-name": "Trac\\xE9 16098",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9532",
    "data-name": "Groupe 9532",
    transform: "translate(665.54 236.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16099",
    "data-name": "Trac\\xE9 16099",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9533",
    "data-name": "Groupe 9533",
    transform: "translate(804.58 277.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16100",
    "data-name": "Trac\\xE9 16100",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9534",
    "data-name": "Groupe 9534",
    transform: "translate(888.651 131.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16101",
    "data-name": "Trac\\xE9 16101",
    d: "M140.327,93.722,91.1,35.823.006.5.189,0,91.411,35.376l.045.053L140.73,93.383Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9535",
    "data-name": "Groupe 9535",
    transform: "translate(1036.934 346.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16102",
    "data-name": "Trac\\xE9 16102",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9536",
    "data-name": "Groupe 9536",
    transform: "translate(1184.902 268.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16103",
    "data-name": "Trac\\xE9 16103",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9537",
    "data-name": "Groupe 9537",
    transform: "translate(1406.902 114.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16238",
    "data-name": "Trac\\xE9 16238",
    d: "M0,0,.532.006,2.975,205.868l-.532-.006Z",
    transform: "translate(0.001 0.098) rotate(-10.545)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9538",
    "data-name": "Groupe 9538",
    transform: "translate(1321.385 265.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16239",
    "data-name": "Trac\\xE9 16239",
    d: "M0,0,.529,0,1.752,146.819l-.529,0Z",
    transform: "translate(0.003 0.227) rotate(-25.108)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9539",
    "data-name": "Groupe 9539",
    transform: "translate(1029.249 225.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16104",
    "data-name": "Trac\\xE9 16104",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9540",
    "data-name": "Groupe 9540",
    transform: "translate(585.815 209.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16105",
    "data-name": "Trac\\xE9 16105",
    d: "M218.695,68.772l-139.04-41.5L.006.508.165,0l79.64,26.762,139.03,41.5Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9541",
    "data-name": "Groupe 9541",
    transform: "translate(698.119 138.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16106",
    "data-name": "Trac\\xE9 16106",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9542",
    "data-name": "Groupe 9542",
    transform: "translate(723.26 175.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16107",
    "data-name": "Trac\\xE9 16107",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9543",
    "data-name": "Groupe 9543",
    transform: "translate(698.061 138.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16108",
    "data-name": "Trac\\xE9 16108",
    d: "M111.038,79.924,25.085,37.357l.228-.477L111,79.317l67.347-39.858L.007.523.108,0,179.8,39.231Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9544",
    "data-name": "Groupe 9544",
    transform: "translate(888.749 131.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16109",
    "data-name": "Trac\\xE9 16109",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9545",
    "data-name": "Groupe 9545",
    transform: "translate(495.378 231.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16110",
    "data-name": "Trac\\xE9 16110",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9546",
    "data-name": "Groupe 9546",
    transform: "translate(607.587 290.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16111",
    "data-name": "Trac\\xE9 16111",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9547",
    "data-name": "Groupe 9547",
    transform: "translate(494.424 164.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16240",
    "data-name": "Trac\\xE9 16240",
    d: "M0,0,137.188,1l0,.539L0,.539Z",
    transform: "translate(0.833 66.039) rotate(-28.465)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9548",
    "data-name": "Groupe 9548",
    transform: "translate(307.71 347.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16112",
    "data-name": "Trac\\xE9 16112",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9549",
    "data-name": "Groupe 9549",
    transform: "translate(441.212 230.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16241",
    "data-name": "Trac\\xE9 16241",
    d: "M0,0,54.755.657l.006.536L.006.536Z",
    transform: "translate(0.124 9.825) rotate(-10.299)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9550",
    "data-name": "Groupe 9550",
    transform: "translate(307.71 347.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16113",
    "data-name": "Trac\\xE9 16113",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9551",
    "data-name": "Groupe 9551",
    transform: "translate(191.422 296.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16114",
    "data-name": "Trac\\xE9 16114",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9552",
    "data-name": "Groupe 9552",
    transform: "translate(105.205 300.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16115",
    "data-name": "Trac\\xE9 16115",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9553",
    "data-name": "Groupe 9553",
    transform: "translate(83.52 162.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16116",
    "data-name": "Trac\\xE9 16116",
    d: "M184.4,57.875,81.127,25,.006.513.149,0,81.273,24.494,184.555,57.367Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9554",
    "data-name": "Groupe 9554",
    transform: "translate(495.376 231.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16117",
    "data-name": "Trac\\xE9 16117",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9555",
    "data-name": "Groupe 9555",
    transform: "translate(441.388 240.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16118",
    "data-name": "Trac\\xE9 16118",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9556",
    "data-name": "Groupe 9556",
    transform: "translate(495.376 231.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16119",
    "data-name": "Trac\\xE9 16119",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9557",
    "data-name": "Groupe 9557",
    transform: "translate(543.94 367.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16120",
    "data-name": "Trac\\xE9 16120",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9558",
    "data-name": "Groupe 9558",
    transform: "translate(25.697 0.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16121",
    "data-name": "Trac\\xE9 16121",
    d: "M2.264,139.461l-.507-.181L48.072.606l75.137,112.688-.442.288L48.238,1.807Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9559",
    "data-name": "Groupe 9559",
    transform: "translate(105.205 300.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16122",
    "data-name": "Trac\\xE9 16122",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9560",
    "data-name": "Groupe 9560",
    transform: "translate(3.254 239.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16123",
    "data-name": "Trac\\xE9 16123",
    d: "M221.3,213.132,187.984,57.473,46.809,134.387,0,.17l.5-.164L47.1,133.614,188.353,56.657l.047.221,116.483,51.506-.216.27ZM188.537,57.516l33.047,154.4L304.03,108.584Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9561",
    "data-name": "Groupe 9561",
    transform: "translate(543.94 367.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16124",
    "data-name": "Trac\\xE9 16124",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9562",
    "data-name": "Groupe 9562",
    transform: "translate(253.06 153.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16125",
    "data-name": "Trac\\xE9 16125",
    d: "M242.2,77.893,99.722,4.89.007.534.017,0,99.85,4.362l.053.027,142.53,73.03Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9563",
    "data-name": "Groupe 9563",
    transform: "translate(1.405 111.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16126",
    "data-name": "Trac\\xE9 16126",
    d: "M1.624,128.755,26.113,27.893,82.148,50.952l65.3-49.094L163.577,75.7l-.522.1L147.109,2.79,82.368,51.462ZM26.49,28.62,2.581,127.091,81.71,51.343Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9564",
    "data-name": "Groupe 9564",
    transform: "translate(352.846 157.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16127",
    "data-name": "Trac\\xE9 16127",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9565",
    "data-name": "Groupe 9565",
    transform: "translate(426.256 230.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16242",
    "data-name": "Trac\\xE9 16242",
    d: "M0,1.615,150.37.54l0,.54L0,2.155Z",
    transform: "translate(0.268 134.677) rotate(-63.061)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9566",
    "data-name": "Groupe 9566",
    transform: "translate(352.571 157.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16128",
    "data-name": "Trac\\xE9 16128",
    d: "M88.638,82.993.55,1.23l.617,48.951-.534-.007L0,0,89,82.606Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9567",
    "data-name": "Groupe 9567",
    transform: "translate(606.724 235.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16311",
    "data-name": "Trac\\xE9 16311",
    d: "M0,0,79.192.1V.644L0,.541Z",
    transform: "matrix(0.731, -0.683, 0.683, 0.731, 0.69, 54.735)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9568",
    "data-name": "Groupe 9568",
    transform: "translate(888.456 113.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16129",
    "data-name": "Trac\\xE9 16129",
    d: "M91.183,54.217,88.893,1.774.355,19.384.238,18.86,89.4,1.127l2.318,53.08Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9569",
    "data-name": "Groupe 9569",
    transform: "translate(876.889 177.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16130",
    "data-name": "Trac\\xE9 16130",
    d: "M192.418,187.851,53.389,115.807l-.04-.086L0,.219.487.006,53.794,115.421l138.86,71.958Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9570",
    "data-name": "Groupe 9570",
    transform: "translate(1182.006 54.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16131",
    "data-name": "Trac\\xE9 16131",
    d: "M3.086,215.031l-.378-.386,113.4-110.816-79.4-8.69.045-.531,79.819,8.737,65.092-91.439.114-.014,71.513-8.7L225.357,60.676l-.093.037L116.846,103.859ZM181.975,12.408l-64.522,90.629L224.962,60.253,252.38,3.843Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9571",
    "data-name": "Groupe 9571",
    transform: "translate(1068.157 267.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16132",
    "data-name": "Trac\\xE9 16132",
    d: "M1.307,97.963l-.079-.529L129.791,81.449l-13.309-79.9.527-.075,13.4,80.438-.269.033Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9572",
    "data-name": "Groupe 9572",
    transform: "translate(928.694 166.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16243",
    "data-name": "Trac\\xE9 16243",
    d: "M0,1.738,135.132.539l0,.539L0,2.277Z",
    transform: "translate(-0.017 125.813) rotate(-68.091)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9573",
    "data-name": "Groupe 9573",
    transform: "translate(877.135 177.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16133",
    "data-name": "Trac\\xE9 16133",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9574",
    "data-name": "Groupe 9574",
    transform: "translate(722.182 102.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16134",
    "data-name": "Trac\\xE9 16134",
    d: "M154.731,75.742l-49.3-73.664L1.233,73.592l-.31-.442L105.562,1.33l49.611,74.122Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9575",
    "data-name": "Groupe 9575",
    transform: "translate(664.58 163.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16135",
    "data-name": "Trac\\xE9 16135",
    d: "M139.694,115.341l.041-.539,4.476-59.749L1,73.454l-.081-.53L144.794,54.437l-4.485,59.878L315.179,3.972l.294.454Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9576",
    "data-name": "Groupe 9576",
    transform: "translate(494.477 164.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16136",
    "data-name": "Trac\\xE9 16136",
    d: "M.966,66.415.831,65.9l90.429-21.43L121.784,1.535l.438.316L91.586,44.94l-.1.023Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9577",
    "data-name": "Groupe 9577",
    transform: "translate(723.26 175.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16137",
    "data-name": "Trac\\xE9 16137",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9578",
    "data-name": "Groupe 9578",
    transform: "translate(804.582 277.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16138",
    "data-name": "Trac\\xE9 16138",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9579",
    "data-name": "Groupe 9579",
    transform: "translate(877.135 177.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16139",
    "data-name": "Trac\\xE9 16139",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9580",
    "data-name": "Groupe 9580",
    transform: "translate(616.021 137.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16140",
    "data-name": "Trac\\xE9 16140",
    d: "M107.02,38.358,82,1.674.552,29.639l-.185-.505L82.2,1.036l.118.173,25.142,36.857Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9581",
    "data-name": "Groupe 9581",
    transform: "translate(977.602 114.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16141",
    "data-name": "Trac\\xE9 16141",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9582",
    "data-name": "Groupe 9582",
    transform: "translate(977.602 114.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16142",
    "data-name": "Trac\\xE9 16142",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9583",
    "data-name": "Groupe 9583",
    transform: "translate(1028.436 173.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16244",
    "data-name": "Trac\\xE9 16244",
    d: "M0,0,113.822.915l0,.539L0,.539Z",
    transform: "translate(0.645 51.158) rotate(-26.44)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9584",
    "data-name": "Groupe 9584",
    transform: "translate(1195.675 156.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16143",
    "data-name": "Trac\\xE9 16143",
    d: "M2.734,192.954l-.306-.445,123.228-82.945L102.773,1.4l.523-.1,22.956,108.512-.145.1Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9585",
    "data-name": "Groupe 9585",
    transform: "translate(1385.033 398.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16144",
    "data-name": "Trac\\xE9 16144",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9586",
    "data-name": "Groupe 9586",
    transform: "translate(1195.056 156.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16145",
    "data-name": "Trac\\xE9 16145",
    d: "M95.346,297.817,2.426,192.39l.835.221,186.606,49.335,61.97-81.669L103.46,1.668l.386-.359,148.69,158.943-.135.178-62.315,82.123-.172-.046L3.973,193.348l91.77,104.121Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9587",
    "data-name": "Groupe 9587",
    transform: "translate(1131.108 147.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16245",
    "data-name": "Trac\\xE9 16245",
    d: "M0,0,91.144.971l.006.537L.006.537Z",
    transform: "translate(0.348 27.601) rotate(-17.51)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9588",
    "data-name": "Groupe 9588",
    transform: "translate(1184.902 268.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16146",
    "data-name": "Trac\\xE9 16146",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9589",
    "data-name": "Groupe 9589",
    transform: "translate(1217.256 64.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16147",
    "data-name": "Trac\\xE9 16147",
    d: "M73.608,389.86l-.527-.1L104.088,202.07,1.07,84.83l.279-.159L146.622,1.848,190.106,50.32l-.394.351L146.522,2.526,1.9,84.977,104.657,201.918l-.021.126Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9590",
    "data-name": "Groupe 9590",
    transform: "translate(1298.709 157.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16148",
    "data-name": "Trac\\xE9 16148",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9591",
    "data-name": "Groupe 9591",
    transform: "translate(1318.594 55.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16149",
    "data-name": "Trac\\xE9 16149",
    d: "M128.554,260.751,2.651,210.2,88.424,58.277l75.456,10.5L116.034,1.77l.432-.3,48.56,68.005L88.719,58.856,3.419,209.935l125.324,50.321Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9592",
    "data-name": "Groupe 9592",
    transform: "translate(665.54 236.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16150",
    "data-name": "Trac\\xE9 16150",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9593",
    "data-name": "Groupe 9593",
    transform: "translate(665.54 236.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16151",
    "data-name": "Trac\\xE9 16151",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9594",
    "data-name": "Groupe 9594",
    transform: "translate(665.54 236.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16152",
    "data-name": "Trac\\xE9 16152",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9595",
    "data-name": "Groupe 9595",
    transform: "translate(616.458 166.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16153",
    "data-name": "Trac\\xE9 16153",
    d: "M49.278,70.224l-.392-.372L106.222,9.311.007.533.038,0,107.382,8.872Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9597",
    "data-name": "Groupe 9597",
    transform: "translate(74.003 1.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16154",
    "data-name": "Trac\\xE9 16154",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9598",
    "data-name": "Groupe 9598",
    transform: "translate(1.895 150.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16155",
    "data-name": "Trac\\xE9 16155",
    d: "M103.813,150.423l-.483-.289L1.123,89.074,89.149,60.585,81.591,12.517l.527-.07,7.543,47.973,73.229-23.7L251.228,3.166l.2.5-88.35,33.559L89.746,60.957ZM2.405,89.224l100.706,60.164L89.233,61.123Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9600",
    "data-name": "Groupe 9600",
    transform: "translate(586.052 209.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16156",
    "data-name": "Trac\\xE9 16156",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9601",
    "data-name": "Groupe 9601",
    transform: "translate(607.421 290.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16157",
    "data-name": "Trac\\xE9 16157",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9602",
    "data-name": "Groupe 9602",
    transform: "translate(495.048 230.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16158",
    "data-name": "Trac\\xE9 16158",
    d: "M48.791,136.628,0,0,112.493,59.592l-.241.47L.958,1.105,49.294,136.46Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9603",
    "data-name": "Groupe 9603",
    transform: "translate(616.411 166.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16246",
    "data-name": "Trac\\xE9 16246",
    d: "M0,0,.528,0,.931,85.3l-.528,0Z",
    transform: "translate(0.004 0.305) rotate(-34.842)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9604",
    "data-name": "Groupe 9604",
    transform: "translate(809.249 219.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16159",
    "data-name": "Trac\\xE9 16159",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9605",
    "data-name": "Groupe 9605",
    transform: "translate(827.828 103.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16160",
    "data-name": "Trac\\xE9 16160",
    d: "M0,0",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9607",
    "data-name": "Groupe 9607",
    transform: "translate(980.057 167.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16161",
    "data-name": "Trac\\xE9 16161",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9608",
    "data-name": "Groupe 9608",
    transform: "translate(977.654 114.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16247",
    "data-name": "Trac\\xE9 16247",
    d: "M2.014,0l.529,0L1.058,165.562l-.529,0Z",
    transform: "translate(-0.718 2.377) rotate(-68.916)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9609",
    "data-name": "Groupe 9609",
    transform: "translate(827.714 103.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16162",
    "data-name": "Trac\\xE9 16162",
    d: "M494.115,162.9,303.927,72.315,152.335,64.133,49.216,74.441l11.659-45.52L.006.485.222,0,61.5,28.632l-.055.217L49.927,73.833,152.31,63.6l151.739,8.187.049.023,189.919,90.452L655.305,21.435l.358.406Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9610",
    "data-name": "Groupe 9610",
    transform: "translate(1066.653 146.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16163",
    "data-name": "Trac\\xE9 16163",
    d: "M3.1,218.352l-.349-.414L118.165,121.8,151.983,1.915l.514.157L118.636,122.114l-.062.051Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9612",
    "data-name": "Groupe 9612",
    transform: "translate(73.736 1.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16248",
    "data-name": "Trac\\xE9 16248",
    d: "M0,0,.534.007,2.565,161.452l-.534-.007Z",
    transform: "translate(0 0.026) rotate(-2.74)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9613",
    "data-name": "Groupe 9613",
    transform: "translate(267.191 156.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16249",
    "data-name": "Trac\\xE9 16249",
    d: "M0,0,105.126.44l0,.54L0,.54Z",
    transform: "translate(0.796 63.145) rotate(-36.424)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9614",
    "data-name": "Groupe 9614",
    transform: "translate(353.622 207.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16164",
    "data-name": "Trac\\xE9 16164",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9615",
    "data-name": "Groupe 9615",
    transform: "translate(441.329 240.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16250",
    "data-name": "Trac\\xE9 16250",
    d: "M0,0,.528,0,1.034,163.11l-.528,0Z",
    transform: "matrix(0.78, -0.626, 0.626, 0.78, 0.004, 0.334)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9616",
    "data-name": "Groupe 9616",
    transform: "translate(428.346 365.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16165",
    "data-name": "Trac\\xE9 16165",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9617",
    "data-name": "Groupe 9617",
    transform: "translate(428.346 365.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16166",
    "data-name": "Trac\\xE9 16166",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9619",
    "data-name": "Groupe 9619",
    transform: "translate(616.632 166.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16167",
    "data-name": "Trac\\xE9 16167",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9620",
    "data-name": "Groupe 9620",
    transform: "translate(809.091 217.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16168",
    "data-name": "Trac\\xE9 16168",
    d: "M121.554,75.774l-.15-.093L.006.455.279,0,121.527,75.137,220.085,7.415l.31.442Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9621",
    "data-name": "Groupe 9621",
    transform: "translate(1185.053 268.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16169",
    "data-name": "Trac\\xE9 16169",
    d: "M0,0",
    transform: "translate(0 0)",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9623",
    "data-name": "Groupe 9623",
    transform: "translate(1131.702 175.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16170",
    "data-name": "Trac\\xE9 16170",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9624",
    "data-name": "Groupe 9624",
    transform: "translate(1131.422 155.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16251",
    "data-name": "Trac\\xE9 16251",
    d: "M0,0,168.088,2.082l.007.536L.007.536Z",
    transform: "matrix(0.993, -0.119, 0.119, 0.993, 0.253, 20.055)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9625",
    "data-name": "Groupe 9625",
    transform: "translate(190.227 204.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16171",
    "data-name": "Trac\\xE9 16171",
    d: "M238.287,162,198.715,78.324,117.5,143.687,77.8,16.035,1.538,92l-.382-.383,76.89-76.59L117.77,142.775l80.707-64.954L162.641,2.049l63.71,53.337L251.646,35.03,247.63,73.2l106.4,89.08-.337.406L247.563,73.833ZM199.139,77.982l38.814,82.07,9.116-86.634L226.356,56.078ZM164.149,4,198.9,77.48l27.032-21.755Zm62.625,51.742,20.36,17.045,3.843-36.525Z",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9626",
    "data-name": "Groupe 9626",
    transform: "translate(586.052 209.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16172",
    "data-name": "Trac\\xE9 16172",
    d: "M0,0",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9627",
    "data-name": "Groupe 9627",
    transform: "translate(723.199 175.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16252",
    "data-name": "Trac\\xE9 16252",
    d: "M0,0,.527,0,.965,130.909l-.527,0Z",
    transform: "translate(0.004 0.33) rotate(-38.213)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9628",
    "data-name": "Groupe 9628",
    transform: "translate(585.528 173.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16173",
    "data-name": "Trac\\xE9 16173",
    d: "M.594,36.448.453,35.93,137.846,1.737h.034L291.755,3.964l.006.534L137.921,2.272Z",
    transform: "translate(0 0)",
    fill: "#002b53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9629",
    "data-name": "Groupe 9629",
    transform: "translate(50.127 373.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16253",
    "data-name": "Trac\\xE9 16253",
    d: "M0,0,.528,0l.586,88.764-.528,0Z",
    transform: "translate(0.003 0.267) rotate(-30.037)",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9631",
    "data-name": "Groupe 9631",
    transform: "translate(930.259 265.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16254",
    "data-name": "Trac\\xE9 16254",
    d: "M0,0,255.546,3.178l.007.535L.007.535Z",
    transform: "matrix(0.994, -0.107, 0.107, 0.994, 0.347, 27.499)",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9733",
    "data-name": "Groupe 9733",
    transform: "translate(0 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9634",
    "data-name": "Groupe 9634",
    transform: "translate(1434.363 58.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9633",
    "data-name": "Groupe 9633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16255",
    "data-name": "Trac\\xE9 16255",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9636",
    "data-name": "Groupe 9636",
    transform: "translate(1363.348 66.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9635",
    "data-name": "Groupe 9635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16256",
    "data-name": "Trac\\xE9 16256",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9638",
    "data-name": "Groupe 9638",
    transform: "translate(1218.262 149.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9637",
    "data-name": "Groupe 9637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16257",
    "data-name": "Trac\\xE9 16257",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9640",
    "data-name": "Groupe 9640",
    transform: "translate(979.425 168.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9639",
    "data-name": "Groupe 9639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16258",
    "data-name": "Trac\\xE9 16258",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9642",
    "data-name": "Groupe 9642",
    transform: "translate(722.78 176.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9641",
    "data-name": "Groupe 9641",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16174",
    "data-name": "Trac\\xE9 16174",
    d: "M2.471,6.155A3.032,3.032,0,0,0,6.16,2.469,3.191,3.191,0,0,0,3.817.127,3.032,3.032,0,0,0,.128,3.813,3.193,3.193,0,0,0,2.471,6.155Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9644",
    "data-name": "Groupe 9644",
    transform: "translate(977.12 115.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9643",
    "data-name": "Groupe 9643",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16175",
    "data-name": "Trac\\xE9 16175",
    d: "M.9,5.381C4.243,7.964,7.971,4.239,5.386.9,2.045-1.681-1.683,2.043.9,5.381Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9646",
    "data-name": "Groupe 9646",
    transform: "translate(352.991 208.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9645",
    "data-name": "Groupe 9645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16259",
    "data-name": "Trac\\xE9 16259",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9648",
    "data-name": "Groupe 9648",
    transform: "translate(164.241 187.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9647",
    "data-name": "Groupe 9647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16176",
    "data-name": "Trac\\xE9 16176",
    d: "M3.183,6.243A3.014,3.014,0,0,0,6.249,3.18,3.2,3.2,0,0,0,3.1.039,3.014,3.014,0,0,0,.039,3.1,3.2,3.2,0,0,0,3.183,6.243Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9650",
    "data-name": "Groupe 9650",
    transform: "translate(804.1 278.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9649",
    "data-name": "Groupe 9649",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16260",
    "data-name": "Trac\\xE9 16260",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9652",
    "data-name": "Groupe 9652",
    transform: "translate(3.027 240.032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9651",
    "data-name": "Groupe 9651",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16261",
    "data-name": "Trac\\xE9 16261",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9654",
    "data-name": "Groupe 9654",
    transform: "translate(224.05 452.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9653",
    "data-name": "Groupe 9653",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16177",
    "data-name": "Trac\\xE9 16177",
    d: "M2.471,6.155A3.032,3.032,0,0,0,6.16,2.469,3.192,3.192,0,0,0,3.817.127,3.032,3.032,0,0,0,.128,3.814,3.193,3.193,0,0,0,2.471,6.155Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9656",
    "data-name": "Groupe 9656",
    transform: "translate(104.725 300.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9655",
    "data-name": "Groupe 9655",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16262",
    "data-name": "Trac\\xE9 16262",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9658",
    "data-name": "Groupe 9658",
    transform: "translate(440.908 240.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9657",
    "data-name": "Groupe 9657",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16263",
    "data-name": "Trac\\xE9 16263",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9660",
    "data-name": "Groupe 9660",
    transform: "translate(607.106 290.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9659",
    "data-name": "Groupe 9659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16264",
    "data-name": "Trac\\xE9 16264",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9662",
    "data-name": "Groupe 9662",
    transform: "translate(876.654 178.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9661",
    "data-name": "Groupe 9661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16265",
    "data-name": "Trac\\xE9 16265",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9664",
    "data-name": "Groupe 9664",
    transform: "translate(827.197 104.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9663",
    "data-name": "Groupe 9663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16266",
    "data-name": "Trac\\xE9 16266",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9666",
    "data-name": "Groupe 9666",
    transform: "translate(697.638 139.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9665",
    "data-name": "Groupe 9665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16267",
    "data-name": "Trac\\xE9 16267",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9668",
    "data-name": "Groupe 9668",
    transform: "translate(808.602 218.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9667",
    "data-name": "Groupe 9667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16268",
    "data-name": "Trac\\xE9 16268",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9670",
    "data-name": "Groupe 9670",
    transform: "translate(1068.944 365.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9669",
    "data-name": "Groupe 9669",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16178",
    "data-name": "Trac\\xE9 16178",
    d: "M3.183,6.243A3.014,3.014,0,0,0,6.249,3.181,3.2,3.2,0,0,0,3.1.039,3.014,3.014,0,0,0,.039,3.1,3.2,3.2,0,0,0,3.183,6.243Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9672",
    "data-name": "Groupe 9672",
    transform: "translate(1321.148 266.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9671",
    "data-name": "Groupe 9671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16179",
    "data-name": "Trac\\xE9 16179",
    d: "M3.183,6.244A3.015,3.015,0,0,0,6.249,3.181,3.2,3.2,0,0,0,3.1.039,3.014,3.014,0,0,0,.039,3.1,3.2,3.2,0,0,0,3.183,6.244Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9674",
    "data-name": "Groupe 9674",
    transform: "translate(1446.762 317.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9673",
    "data-name": "Groupe 9673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16269",
    "data-name": "Trac\\xE9 16269",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9676",
    "data-name": "Groupe 9676",
    transform: "translate(49.728 373.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9675",
    "data-name": "Groupe 9675",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16180",
    "data-name": "Trac\\xE9 16180",
    d: "M3.183,6.243A3.014,3.014,0,0,0,6.249,3.18,3.2,3.2,0,0,0,3.1.039,3.014,3.014,0,0,0,.039,3.1,3.2,3.2,0,0,0,3.183,6.243Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9678",
    "data-name": "Groupe 9678",
    transform: "translate(665.06 236.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9677",
    "data-name": "Groupe 9677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16270",
    "data-name": "Trac\\xE9 16270",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9680",
    "data-name": "Groupe 9680",
    transform: "translate(888.272 132.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9679",
    "data-name": "Groupe 9679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16271",
    "data-name": "Trac\\xE9 16271",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9682",
    "data-name": "Groupe 9682",
    transform: "translate(1197.776 349.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9681",
    "data-name": "Groupe 9681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16272",
    "data-name": "Trac\\xE9 16272",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9684",
    "data-name": "Groupe 9684",
    transform: "translate(1384.553 399.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9683",
    "data-name": "Groupe 9683",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16181",
    "data-name": "Trac\\xE9 16181",
    d: "M3.183,6.243A3.014,3.014,0,0,0,6.249,3.18,3.2,3.2,0,0,0,3.1.039,3.014,3.014,0,0,0,.039,3.1,3.2,3.2,0,0,0,3.183,6.243Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9686",
    "data-name": "Groupe 9686",
    transform: "translate(1290.12 454.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9685",
    "data-name": "Groupe 9685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16273",
    "data-name": "Trac\\xE9 16273",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9688",
    "data-name": "Groupe 9688",
    transform: "translate(1475.36 425.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9687",
    "data-name": "Groupe 9687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16274",
    "data-name": "Trac\\xE9 16274",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9690",
    "data-name": "Groupe 9690",
    transform: "translate(930 293.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9689",
    "data-name": "Groupe 9689",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16182",
    "data-name": "Trac\\xE9 16182",
    d: "M.9,5.381C4.243,7.964,7.971,4.239,5.386.9,2.046-1.681-1.683,2.044.9,5.381Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9692",
    "data-name": "Groupe 9692",
    transform: "translate(1028.734 225.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9691",
    "data-name": "Groupe 9691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16275",
    "data-name": "Trac\\xE9 16275",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9694",
    "data-name": "Groupe 9694",
    transform: "translate(1131.07 176.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9693",
    "data-name": "Groupe 9693",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16183",
    "data-name": "Trac\\xE9 16183",
    d: "M3.183,6.243A3.014,3.014,0,0,0,6.249,3.18,3.2,3.2,0,0,0,3.105.039,3.014,3.014,0,0,0,.039,3.1,3.2,3.2,0,0,0,3.183,6.243Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9696",
    "data-name": "Groupe 9696",
    transform: "translate(1184.422 269.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9695",
    "data-name": "Groupe 9695",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16276",
    "data-name": "Trac\\xE9 16276",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9698",
    "data-name": "Groupe 9698",
    transform: "translate(1298.229 158.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9697",
    "data-name": "Groupe 9697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16277",
    "data-name": "Trac\\xE9 16277",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9700",
    "data-name": "Groupe 9700",
    transform: "translate(1406.685 115.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9699",
    "data-name": "Groupe 9699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16278",
    "data-name": "Trac\\xE9 16278",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9702",
    "data-name": "Groupe 9702",
    transform: "translate(1482.566 125.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9701",
    "data-name": "Groupe 9701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16279",
    "data-name": "Trac\\xE9 16279",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9704",
    "data-name": "Groupe 9704",
    transform: "translate(267.519 220.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9703",
    "data-name": "Groupe 9703"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16280",
    "data-name": "Trac\\xE9 16280",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9706",
    "data-name": "Groupe 9706",
    transform: "translate(252.592 154.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9705",
    "data-name": "Groupe 9705",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16281",
    "data-name": "Trac\\xE9 16281",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9708",
    "data-name": "Groupe 9708",
    transform: "translate(82.654 162.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9707",
    "data-name": "Groupe 9707",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16282",
    "data-name": "Trac\\xE9 16282",
    d: "M3.092.038A3.2,3.2,0,0,1,6.223,3.19,3.014,3.014,0,0,1,3.168,6.267,3.2,3.2,0,0,1,.038,3.115,3.014,3.014,0,0,1,3.092.038Z",
    transform: "translate(0.013 0.994) rotate(-9.217)",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9710",
    "data-name": "Groupe 9710",
    transform: "translate(27.226 140.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9709",
    "data-name": "Groupe 9709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16283",
    "data-name": "Trac\\xE9 16283",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9712",
    "data-name": "Groupe 9712",
    transform: "translate(94.667 450.495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9711",
    "data-name": "Groupe 9711",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16284",
    "data-name": "Trac\\xE9 16284",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9714",
    "data-name": "Groupe 9714",
    transform: "translate(427.715 366.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9713",
    "data-name": "Groupe 9713",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16184",
    "data-name": "Trac\\xE9 16184",
    d: "M3.183,6.243A3.014,3.014,0,0,0,6.249,3.18,3.2,3.2,0,0,0,3.1.039,3.014,3.014,0,0,0,.039,3.1,3.2,3.2,0,0,0,3.183,6.243Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9716",
    "data-name": "Groupe 9716",
    transform: "translate(616 167.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9715",
    "data-name": "Groupe 9715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16285",
    "data-name": "Trac\\xE9 16285",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9718",
    "data-name": "Groupe 9718",
    transform: "translate(585.42 210.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9717",
    "data-name": "Groupe 9717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16286",
    "data-name": "Trac\\xE9 16286",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9720",
    "data-name": "Groupe 9720",
    transform: "translate(352.366 158.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9719",
    "data-name": "Groupe 9719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16287",
    "data-name": "Trac\\xE9 16287",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9722",
    "data-name": "Groupe 9722",
    transform: "translate(148.205 114.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9721",
    "data-name": "Groupe 9721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16185",
    "data-name": "Trac\\xE9 16185",
    d: "M3.183,6.243A3.014,3.014,0,0,0,6.249,3.18,3.2,3.2,0,0,0,3.1.039,3.014,3.014,0,0,0,.039,3.1,3.2,3.2,0,0,0,3.183,6.243Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9724",
    "data-name": "Groupe 9724",
    transform: "translate(72.077 0.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9723",
    "data-name": "Groupe 9723",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_738",
    "data-name": "Ellipse 738",
    cx: 3.079,
    cy: 3.119,
    rx: 3.079,
    ry: 3.119,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0.056, 4.406)",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9726",
    "data-name": "Groupe 9726",
    transform: "translate(190.942 297.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9725",
    "data-name": "Groupe 9725",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16288",
    "data-name": "Trac\\xE9 16288",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9728",
    "data-name": "Groupe 9728",
    transform: "translate(307.23 348.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9727",
    "data-name": "Groupe 9727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16186",
    "data-name": "Trac\\xE9 16186",
    d: "M3.183,6.243A3.014,3.014,0,0,0,6.249,3.18,3.2,3.2,0,0,0,3.1.039,3.014,3.014,0,0,0,.039,3.1,3.2,3.2,0,0,0,3.183,6.243Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9730",
    "data-name": "Groupe 9730",
    transform: "translate(543.46 367.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9729",
    "data-name": "Groupe 9729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16289",
    "data-name": "Trac\\xE9 16289",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9732",
    "data-name": "Groupe 9732",
    transform: "translate(494.896 231.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9731",
    "data-name": "Groupe 9731",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16290",
    "data-name": "Trac\\xE9 16290",
    d: "M3.1.039A3.2,3.2,0,0,1,6.249,3.18,3.011,3.011,0,0,1,3.183,6.243,3.2,3.2,0,0,1,.039,3.1,3.011,3.011,0,0,1,3.1.039Z",
    fill: "#002b53"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnexionImageBack);
export default __webpack_public_path__ + "static/media/connexion_image_back.bb06df314f2f999123bfd3ef4ccd7012.svg";
export { ForwardRef as ReactComponent };